__turbopack_context__.v({
  "dark": "ojWxtq_dark",
  "footnotes": "ojWxtq_footnotes",
  "light": "ojWxtq_light",
  "placeholder": "ojWxtq_placeholder",
});
